// El registro del service worker, compartido por el portal y el calendario (6.7 + PWA del
// calendario, 28 ago 2026).
//
// Vive acá y no copiado en las dos páginas por lo mismo que `agenda-ui.js`: dos copias del mismo
// registro terminan divergiendo, y la que se arregla nunca es la que el usuario está corriendo.
//
// ⚠️ **El calendario lo necesita por dos motivos distintos y los dos importan.** Uno: desde que
// tiene manifiesto propio se instala como app, y sin service worker el navegador no ofrece
// instalarla. Dos: `push.js` hace `navigator.serviceWorker.ready`, que **espera para siempre** si
// nadie registró uno — antes el calendario dependía de que el dueño hubiera abierto el portal
// alguna vez en ese teléfono, y si no, activar las notificaciones se quedaba colgado sin error.
//
// Lo que `sw.js` **no** cachea —la API y el HTML— está explicado ahí mismo, y es lo que evita
// repetir el incidente de 1.8: navegadores sirviendo un bundle viejo que le habla a un backend que
// ya no existe. Un service worker hace eso mismo pero sobreviviendo a un Ctrl+F5.
export function registrarSW() {
  if (!('serviceWorker' in navigator)) return;
  // Se registra al cargar y sin bloquear nada: si falla, la página funciona igual.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch((e) => {
      console.warn('El service worker no se registró; la app funciona igual.', e);
    });
  });
}
